import React, { useRef } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { SignatureCanvas } from "./SignatureCanvas";

// --- Reusable SignatureModal Component ---
export const SignatureModal = ({ open, handleClose, onSave }) => {
  const signatureCanvasRef = useRef();

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 500,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 2,
    p: { xs: 2, sm: 3, md: 4 }, // Responsive padding
  };

  const handleClear = () => {
    if (signatureCanvasRef.current) {
      signatureCanvasRef.current.clear();
    }
  };

  const handleSaveClick = () => {
    if (signatureCanvasRef.current) {
      const signatureData = signatureCanvasRef.current.getSignature();
      if (signatureData) {
        onSave(signatureData);
      } else {
        console.log("Signature is empty. Nothing to save.");
      }
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="signature-modal-title"
      aria-describedby="signature-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography id="signature-modal-title" variant="h6" component="h2">
          Provide Signature
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box id="signature-modal-description" sx={{ mt: 2, mb: 3 }}>
          <SignatureCanvas ref={signatureCanvasRef} />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button onClick={handleClear} variant="outlined">
            Clear
          </Button>
          <Button onClick={handleSaveClick} variant="contained">
            Save & Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
